import { Colors, Spacing } from '@kvika/audur-theme'
import styled from 'styled-components'

import { GridItem, MainGridContainer } from '../../grid-container'
import { ColumnClass, Gutters } from '../../../utils/types/Types'

import PricingTableRow, { PricingTableRowData } from './PricingTableRow'

type Props = {
	title?: string
	tableFields?: PricingTableRowData[]
}

const Title = styled.h3`
	font-size: 26px;
	line-height: 32px;
	font-weight: 700;
	margin-top: 0px;
	margin-bottom: ${Spacing.Medium}px;
	color: ${Colors.DarkGray};
`

const TableRows = styled.div``

const PricingTable = ({ title, tableFields }: Props) => {
	const hasData = tableFields && tableFields.length > 0

	if (!hasData) {
		return null
	}

	return (
		<MainGridContainer gutters={Gutters.Both} backgroundColor={Colors.White} style={{ paddingBlock: '80px' }}>
			<GridItem className={ColumnClass.All}>
				{title && <Title>{title}</Title>}
				<TableRows>
					{tableFields.map((field, index) => (
						<PricingTableRow key={`pricing-table-row-${index}`} row={field} />
					))}
				</TableRows>
			</GridItem>
		</MainGridContainer>
	)
}

export default PricingTable
